import React, { useState, useEffect,useCallback , useContext  } from "react";

import {
Typography,
Row,
Col,
Form,
Space,
Button,
Select,

}from 'antd';
import { Content } from "antd/es/layout/layout";
import useLineOfWork from "../../../../lib/hooks/useLineOfWork";
import {getListAge,getListYear} from "../../../../services/vocReportService";

import {SearchVocContext,initialSearchValues,initialPageValues} from "../searchContext";
const { Title } = Typography;
const { Option } = Select;
const ListAge = () => {

    const [data, setData] = useState([]);
  
    const fetchData = useCallback(async () => {
      const res = await getListAge();
      if (res.data.code === "0000") {
        const { objectValue } = res.data;
        setData(objectValue);
      }
    }, [setData]);
  
    useEffect(() => {
      fetchData();
    }, [fetchData]);
  
    return [data];
  };
  const ListYear = () => {

    const [data, setData] = useState([]);
  
    const fetchData = useCallback(async () => {
      const res = await getListYear();
      if (res.data.code === "0000") {
        const { objectValue } = res.data;
        setData(objectValue);
      }
    }, [setData]);
  
    useEffect(() => {
      fetchData();
    }, [fetchData]);
  
    return [data];
  };
  const quarter = [
    { value: "1" },
    { value: "2"},
    { value: "3"},
    { value: "4"}
  ];
const Search = () => {
      const {
        setPageValues,
        setSearch,
        searchValues,
        pageValues,
        setSearchValues,
      } = useContext(SearchVocContext);
    const [searchForm] = Form.useForm();
    const [yearOfBudget] = ListYear();
    const [lineOfWorkName] = useLineOfWork();
    const [customerGroupByAge] = ListAge();
    const lineOfWorkList = ['สายงานปฏิบัติการ 1', 'สายงานปฏิบัติการ 2', 'สายงานปฏิบัติการ 3'];
    const lineOfWorkFilter = lineOfWorkName.filter(item => lineOfWorkList.includes(item.nameTh)).sort((a, b) => a.nameTh.localeCompare(b.nameTh));
    const ageFilter = customerGroupByAge.filter(item => item.nameTh !== 'ไม่สามารถระบุข้อมูลได้');



    const onSearch = (value) => {

        setSearch(true);
        let customerGroupByAges = [];
        let lineOfWorkNames = [];
        let yearOfBudgets = [];
        let quarters = [];
        quarters = value?.quarter;
        yearOfBudgets = value?.yearOfBudget;
        if (
            value?.customerGroupByAge &&
            value?.customerGroupByAge.includes("all")
          ) {
            customerGroupByAges = "";
          } else {
            customerGroupByAges = value?.customerGroupByAge;
          }
          if (
            value?.lineOfWorkId &&
            value?.lineOfWorkId.includes("all")
          ) {
            lineOfWorkNames = "";
          } else {
            lineOfWorkNames = value?.lineOfWorkId;
          }
        // customerGroupByAges = value?.customerGroupByAge;
        setSearchValues({
            customerGroupByAge: customerGroupByAges,
            lineOfWorkId: lineOfWorkNames,
            yearOfBudget: yearOfBudgets,
            quarter:quarters
        })}
    const handleClearSearchForm = () => {
        searchForm.resetFields();
        setSearchValues(initialSearchValues);
        setPageValues(initialPageValues);
        setSearch(true);
      };

    return (

    <Content>
        <Form>
            <Row gutter={[24, 24]}>
            <Col span={24}>
                <div className="flex justify-between items-center">
                <Title level={4} style={{ marginTop: 15, color: "#6442A4" }}>
                    รายงาน
                </Title>
                </div>
            </Col>
            </Row>
        </Form>
        <Form 
            layout={"vertical"}
            form={searchForm}
            style={{
            padding: 20,
            backgroundColor: "#fff",
            borderRadius: "12px",
            border: "1px solid #F2F2F2",
            boxShadow: `0px 1px 10px 0px rgba(226, 216, 246, 0.40)`,
        }}
        onFinish={(value) =>
            onSearch({
              ...value,
            })
        }
        >
            <Row gutter={[24, 16]}>
                <Col className="gutter-row" span={6}>
                    <Form.Item name="yearOfBudget">
                        <Select
                            allowClear
                            style={{
                            width: "100%",
                            }}
                            placeholder="ปีงบประมาณ"
                            maxTagCount={"responsive"}
                        >

                            {yearOfBudget.map((a) => (
                            <Option value={a.yearOfBudget}>
                                {Number(a.yearOfBudget) + 543}
                            </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Form.Item name={"quarter"}>
                        <Select
                        allowClear
                        style={{
                            width: "100%",
                        }}
                        placeholder="ไตรมาส"
                        maxTagCount={"responsive"}
                        >
                        {quarter.map((l) => (
                        <Option value={l.value}>{l.value}</Option>
                        ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Form.Item name="customerGroupByAge">
                        <Select
                            allowClear
                            style={{
                            width: "100%",
                            }}
                            placeholder="กลุ่มอายุ"
                            maxTagCount={"responsive"}
                        >
                            <Option value={"all"}>
                                เลือกทั้งหมด
                            </Option>
                            {ageFilter.map((a) => (
                            <Option value={a.age}>
                                {a.nameTh}
                            </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Form.Item name={"lineOfWorkId"}>
                        <Select
                        allowClear
                        style={{
                            width: "100%",
                        }}
                        placeholder="สายปฏิบัติการ"
                        maxTagCount={"responsive"}
                        >
                        <Option key={"all"} value={"all"}>
                            เลือกทั้งหมด
                        </Option>
                        {lineOfWorkFilter.map((l) => (
                        <Option value={l.lineOfWork}>{l.nameTh}</Option>
                        ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={24} align="right">
                    <Space>
                        <Button onClick={handleClearSearchForm}>ล้างข้อมูล</Button>
                        <Button type="primary" htmlType="submit">
                            ค้นหา
                        </Button>
                    </Space>
                </Col>
            </Row>
        </Form>
    </Content>
  );
};

export default Search;